import { Button } from "../ui/button";
interface QuantityPopupProps {
    onCancel:()=>void
    onContinue:()=>void
    message:string
    open:boolean
}
export default function QuantityPopup({onCancel,onContinue,message,open}:QuantityPopupProps) {
    if(!open) return null
    return (
        <div className="fixed inset-0 bg-black/40 z-40 flex items-center justify-center p-4">
            <div className="rounded-lg bg-white p-6 w-full max-w-md">
                <p className="font-semibold text-md text-orange-500">Message</p>
                <p className="mt-2 text-gray-700 text-base">{message}</p>
                <div className="mt-4 flex justify-center gap-6">
                    <Button variant="outline" onClick={onCancel} className="mr-2 flex-1">Cancel</Button>
                    <Button onClick={onContinue} className="bg-primary text-white flex-1">Continue</Button>
                </div>
            </div>
        </div>
    )
}